import { jsxs as w, jsx as r, Fragment as se } from "react/jsx-runtime";
import * as p from "react";
import Re, { Suspense as Pn, Component as zn, useMemo as be, useRef as mt, useState as pt, useEffect as Fn } from "react";
import { I as Ln, a as jn, D as $n, E as Fe, L as Wn, c as gt } from "./Section-DbfMk74d.js";
import { n as Gn, m as Kn } from "./client-DWGhO7r3.js";
import { c as C } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { S as ke } from "./Skeleton-D_CC12vW.js";
import { A as vt, a as bt, C as Ke, E as ot, b as Bn } from "./grid-3x3-D_KKntnt.js";
import { T as Oe } from "./Typography-DjQwU5Xn.js";
import { B as ee } from "./Input-s7q1Bymv.js";
import { S as yt, a as wt } from "./settings-DDvWy7ax.js";
import { flushSync as Un } from "react-dom";
import { C as De } from "./chevron-right-RGp43GeY.js";
import { c as xt, a as Vn, b as O, i as Nt, u as Me, P as pe, h as Yn, g as Xn, e as Mt, d as qn } from "./index-BwqhVa-H.js";
import { a as Hn, u as it } from "./index-DfspMmaX.js";
import { P as Zn, D as Jn } from "./index-B-Qjqgjx.js";
import { c as Ct, A as Qn, u as er, R as tr, F as nr, C as rr, h as sr, a as or, b as ir } from "./Combination-Te-rCbiT.js";
import { P as Le } from "./index-Co1YE7s6.js";
import { c as Et, I as ar, R as lr } from "./index-v1XNqkXV.js";
import { C as dr } from "./check-CVfLJTWr.js";
import { c as Ue } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cr = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], St = Ue("chevrons-up-down", cr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ur = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
], _t = Ue("layout-template", ur);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hr = [
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], It = Ue("trash", hr), Ve = ({
  title: t,
  description: o,
  icon: e,
  illustration: n,
  illustrationSet: s,
  action: i,
  className: a,
  ...l
}) => {
  const h = e ?? (n !== void 0 ? /* @__PURE__ */ r(
    Ln,
    {
      name: n,
      set: s,
      size: 48
    }
  ) : null);
  return /* @__PURE__ */ w(
    "div",
    {
      className: C(
        "flex flex-col items-center justify-center text-center p-8 rounded-[var(--ds-radius-lg)] border-2 border-dashed border-border bg-background",
        a
      ),
      role: "status",
      ...l,
      children: [
        h && /* @__PURE__ */ r("div", { className: "mb-4 text-muted-foreground", children: Re.isValidElement(h) ? Re.cloneElement(h, {
          size: 48,
          "aria-hidden": "true",
          className: "w-12 h-12"
        }) : h }),
        /* @__PURE__ */ r(Oe, { variant: "h3", className: "mb-2 text-foreground", children: t }),
        o && /* @__PURE__ */ r(Oe, { variant: "body", className: "mb-6 max-w-sm text-muted-foreground", children: o }),
        i && /* @__PURE__ */ r(
          ee,
          {
            onClick: i.onClick,
            variant: i.variant || "primary",
            leftIcon: i.icon,
            children: i.label
          }
        )
      ]
    }
  );
};
class fr extends zn {
  constructor(o) {
    super(o), this.resetErrorBoundary = () => {
      var e, n;
      (n = (e = this.props).onReset) == null || n.call(e), this.setState({ hasError: !1, error: null });
    }, this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(o) {
    return { hasError: !0, error: o };
  }
  componentDidCatch(o, e) {
    var n, s;
    (s = (n = this.props).onError) == null || s.call(n, o, e);
  }
  render() {
    if (this.state.hasError) {
      if (typeof this.props.fallback == "function")
        return this.props.fallback(this.state.error, this.resetErrorBoundary);
      const o = Gn(this.state.error), { title: e, description: n } = Kn(o);
      return this.props.fallback || /* @__PURE__ */ r(
        Fe,
        {
          title: e,
          description: n,
          onRetry: this.resetErrorBoundary
        }
      );
    }
    return this.props.children;
  }
}
const ao = ({
  children: t,
  state: o,
  errorFallback: e,
  loadingFallback: n = /* @__PURE__ */ r(Wn, {}),
  emptyFallback: s,
  emptyTitle: i = $n,
  emptyDescription: a = jn,
  onError: l,
  onReset: m
}) => {
  if (o) {
    if (o.isLoading)
      return /* @__PURE__ */ r(se, { children: n });
    if (o.isEmpty) {
      const h = o.onRetry || m;
      return /* @__PURE__ */ r(se, { children: s || /* @__PURE__ */ r(
        Ve,
        {
          title: i,
          description: a,
          action: h ? { label: "Refresh", onClick: h } : void 0
        }
      ) });
    }
    if (o.error || o.isError) {
      const h = o.error instanceof Error ? o.error : new Error("Unknown error"), f = o.onRetry || m || (() => {
      });
      return typeof e == "function" ? /* @__PURE__ */ r(se, { children: e(h, f) }) : e ? /* @__PURE__ */ r(se, { children: e }) : /* @__PURE__ */ r(Fe, { onRetry: f, description: h.message });
    }
    return /* @__PURE__ */ r(se, { children: t });
  }
  return /* @__PURE__ */ r(
    fr,
    {
      fallback: e,
      onError: l,
      onReset: m,
      children: /* @__PURE__ */ r(Pn, { fallback: n, children: t })
    }
  );
}, mr = ({
  data: t,
  columns: o,
  keyExtractor: e,
  onRowClick: n,
  isLoading: s,
  loadingRowCount: i = 5,
  emptyMessage: a = "No results",
  error: l,
  onRetry: m,
  sortConfig: h,
  onSort: f,
  selected: d,
  onSelect: c,
  onSelectAll: x,
  selectAllLabel: b = "Select all rows",
  getRowSelectionLabel: M,
  className: N,
  stickyHeader: _,
  columnVisibility: E,
  enableVirtualization: T,
  virtualItemHeight: A = 53,
  containerHeight: F = 400,
  ...Z
}) => {
  const J = (g, I) => {
    if (typeof e == "function") {
      const S = e(g);
      if (S != null) return String(S);
    }
    if (typeof e == "string" && g && typeof g == "object") {
      const S = g[e];
      if (typeof S == "string" || typeof S == "number")
        return String(S);
    }
    const D = g && typeof g == "object" ? g.id ?? g.key : void 0;
    return String(typeof D == "string" || typeof D == "number" ? D : I);
  }, ae = t.length > 0 && d && t.every((g, I) => d.has(J(g, I))), te = d && d.size > 0 && !ae, P = be(() => o.filter((g) => !E || E[g.key] !== !1), [o, E]), { leftOffsets: ne, rightOffsets: oe } = be(() => {
    const g = {}, I = {};
    let D = 0;
    D += c ? 48 : 0, P.forEach((k) => {
      if (k.pinned === "left") {
        g[k.key] = D;
        let j = 0;
        typeof k.width == "number" ? j = k.width : typeof k.width == "string" && k.width.endsWith("px") ? j = parseInt(k.width, 10) : j = 150, D += j;
      }
    });
    let R = 0;
    return [...P].reverse().forEach((k) => {
      if (k.pinned === "right") {
        I[k.key] = R;
        let j = 0;
        typeof k.width == "number" ? j = k.width : typeof k.width == "string" && k.width.endsWith("px") ? j = parseInt(k.width, 10) : j = 150, R += j;
      }
    }), { leftOffsets: g, rightOffsets: I };
  }, [P, c]), le = mt(null), [K, ge] = Re.useState(0), he = (g) => {
    ge(g.currentTarget.scrollTop);
  }, U = be(() => {
    if (!T) return null;
    const g = t.length * A, I = Math.floor(K / A), D = Math.ceil((typeof F == "number" ? F : parseInt(F) || 400) / A), S = Math.min(t.length, I + D + 5), R = I * A, k = t.slice(I, S), j = g - (I + k.length) * A;
    return { visibleData: k, startSpacer: R, endSpacer: j, startNode: I };
  }, [t, T, K, A, F]), V = T && U ? U.visibleData : t, y = T && U ? U.startSpacer : 0, L = T && U ? U.endSpacer : 0, W = (g) => T && U ? U.startNode + g : g, Y = () => /* @__PURE__ */ r("thead", { className: C("bg-muted", _ && "sticky top-0 z-20"), children: /* @__PURE__ */ w("tr", { children: [
    c && /* @__PURE__ */ r(
      "th",
      {
        scope: "col",
        className: C(
          "px-[calc(var(--density-padding)*1.5)] py-[calc(var(--density-padding)*0.75)] w-4 bg-muted",
          _ && "sticky top-0 z-30",
          Object.keys(ne).length > 0 && "sticky left-0 z-30 border-r border-border"
        ),
        style: { left: 0 },
        children: /* @__PURE__ */ r(
          "input",
          {
            type: "checkbox",
            checked: ae,
            ref: (g) => {
              g && (g.indeterminate = !!te);
            },
            onChange: () => x == null ? void 0 : x(t.map((g, I) => J(g, I))),
            "aria-label": b,
            className: "rounded border-border text-primary focus:ring-ring"
          }
        )
      }
    ),
    P.map((g) => {
      const I = g.pinned === "left", D = g.pinned === "right", S = { width: g.width }, R = (h == null ? void 0 : h.key) === g.key, k = g.sortable ? R ? (h == null ? void 0 : h.direction) === "asc" ? "ascending" : "descending" : "none" : void 0;
      return I && (S.position = "sticky", S.left = ne[g.key] ?? 0, S.zIndex = _ ? 30 : 10), D && (S.position = "sticky", S.right = oe[g.key] ?? 0, S.zIndex = _ ? 30 : 10), /* @__PURE__ */ r(
        "th",
        {
          scope: "col",
          "aria-sort": k,
          className: C(
            "px-[calc(var(--density-padding)*1.5)] py-[calc(var(--density-padding)*0.75)] text-left text-xs font-medium uppercase tracking-wider text-muted-foreground bg-muted",
            g.align === "center" && "text-center",
            g.align === "right" && "text-right",
            g.sortable && "cursor-pointer hover:bg-muted/80 select-none",
            I && "border-r border-border",
            D && "border-l border-border"
          ),
          style: S,
          children: g.sortable ? /* @__PURE__ */ w(
            "button",
            {
              type: "button",
              onClick: () => f == null ? void 0 : f(g.key),
              className: C(
                "flex w-full items-center gap-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)] focus-visible:ring-offset-2",
                g.align === "center" && "justify-center",
                g.align === "right" && "justify-end"
              ),
              "aria-label": `Sort by ${g.header}`,
              children: [
                g.header,
                /* @__PURE__ */ r("span", { className: "text-muted-foreground", children: R ? (h == null ? void 0 : h.direction) === "asc" ? /* @__PURE__ */ r(vt, { className: "h-3 w-3" }) : /* @__PURE__ */ r(bt, { className: "h-3 w-3" }) : /* @__PURE__ */ r(St, { className: "h-3 w-3" }) })
              ]
            }
          ) : /* @__PURE__ */ r("div", { className: C(
            "flex items-center gap-1",
            g.align === "center" && "justify-center",
            g.align === "right" && "justify-end"
          ), children: g.header })
        },
        g.key
      );
    })
  ] }) }), ie = () => /* @__PURE__ */ w("tbody", { className: "divide-y divide-border bg-background", children: [
    y > 0 && /* @__PURE__ */ r("tr", { style: { height: y }, "aria-hidden": "true", children: /* @__PURE__ */ r("td", { colSpan: P.length + (c ? 1 : 0) }) }),
    V.map((g, I) => {
      const D = W(I), S = J(g, D);
      return /* @__PURE__ */ w(
        "tr",
        {
          onClick: () => n == null ? void 0 : n(g),
          onKeyDown: (R) => {
            n && (R.key === "Enter" || R.key === " ") && (R.preventDefault(), n(g));
          },
          className: C(
            "transition-colors hover:bg-muted/50",
            n && "cursor-pointer",
            (d == null ? void 0 : d.has(S)) && "bg-accent/50"
          ),
          tabIndex: n ? 0 : void 0,
          "aria-selected": (d == null ? void 0 : d.has(S)) || void 0,
          style: { height: A },
          children: [
            c && /* @__PURE__ */ r(
              "td",
              {
                className: C(
                  "px-[calc(var(--density-padding)*1.5)] py-[var(--density-padding)] bg-background",
                  Object.keys(ne).length > 0 && "sticky left-0 z-10 border-r border-border",
                  (d == null ? void 0 : d.has(S)) && "bg-accent/50"
                ),
                style: { left: 0 },
                children: /* @__PURE__ */ r(
                  "input",
                  {
                    type: "checkbox",
                    checked: d == null ? void 0 : d.has(S),
                    onChange: (R) => {
                      R.stopPropagation(), c(S);
                    },
                    "aria-label": (M == null ? void 0 : M(g, D)) ?? `Select row ${D + 1}`,
                    className: "rounded border-border text-primary focus:ring-ring"
                  }
                )
              }
            ),
            P.map((R) => {
              const k = R.pinned === "left", j = R.pinned === "right", q = {};
              return k && (q.position = "sticky", q.left = ne[R.key] ?? 0, q.zIndex = 10), j && (q.position = "sticky", q.right = oe[R.key] ?? 0, q.zIndex = 10), /* @__PURE__ */ r(
                "td",
                {
                  className: C(
                    "whitespace-nowrap px-[calc(var(--density-padding)*1.5)] py-[var(--density-padding)] text-sm text-foreground bg-background",
                    R.align === "center" && "text-center",
                    R.align === "right" && "text-right",
                    k && "border-r border-border",
                    j && "border-l border-border",
                    (d == null ? void 0 : d.has(S)) && "bg-accent/50"
                  ),
                  style: q,
                  children: R.render ? R.render(g) : g[R.key]
                },
                `${S}-${R.key}`
              );
            })
          ]
        },
        S
      );
    }),
    L > 0 && /* @__PURE__ */ r("tr", { style: { height: L }, "aria-hidden": "true", children: /* @__PURE__ */ r("td", { colSpan: P.length + (c ? 1 : 0) }) })
  ] }), X = () => /* @__PURE__ */ r("tbody", { className: "divide-y divide-border bg-background", children: Array.from({ length: i }).map((g, I) => /* @__PURE__ */ w("tr", { children: [
    c && /* @__PURE__ */ r("td", { className: "px-[calc(var(--density-padding)*1.5)] py-[var(--density-padding)]", children: /* @__PURE__ */ r(ke, { width: 20, height: 20 }) }),
    P.map((D, S) => /* @__PURE__ */ r("td", { className: "px-[calc(var(--density-padding)*1.5)] py-[var(--density-padding)]", children: /* @__PURE__ */ r(ke, {}) }, S))
  ] }, I)) }), Q = () => /* @__PURE__ */ r("tbody", { children: /* @__PURE__ */ r("tr", { children: /* @__PURE__ */ r("td", { colSpan: P.length + (c ? 1 : 0), className: "p-[calc(var(--density-padding)*1.25)]", children: /* @__PURE__ */ r(
    Fe,
    {
      title: "Error loading data",
      description: (l == null ? void 0 : l.message) || gt,
      onRetry: m,
      className: "border-0 shadow-none bg-transparent"
    }
  ) }) }) }), B = () => /* @__PURE__ */ r("tbody", { children: /* @__PURE__ */ r("tr", { children: /* @__PURE__ */ r("td", { colSpan: P.length + (c ? 1 : 0), className: "p-0", children: /* @__PURE__ */ r(
    Ve,
    {
      title: "No results found",
      description: a,
      className: "border-0 shadow-none py-12"
    }
  ) }) }) });
  return /* @__PURE__ */ r(
    "div",
    {
      className: C("overflow-hidden rounded-[var(--shape-radius-lg)] border border-border shadow-elevation-1", N),
      ...Z,
      children: /* @__PURE__ */ r(
        "div",
        {
          ref: le,
          className: C("overflow-x-auto", T && "overflow-y-auto"),
          style: T || _ ? { maxHeight: F } : void 0,
          onScroll: T ? he : void 0,
          children: /* @__PURE__ */ w("table", { className: "min-w-full divide-y divide-border border-separate border-spacing-0", "aria-busy": s || void 0, children: [
            Y(),
            s ? X() : l ? Q() : t.length === 0 ? B() : ie()
          ] })
        }
      )
    }
  );
}, Dt = ({
  currentPage: t,
  totalPages: o,
  onPageChange: e,
  siblingCount: n = 1,
  variant: s = "default",
  loadMoreMode: i = !1,
  isLoading: a = !1,
  loadMoreText: l = "Load more",
  className: m,
  ...h
}) => {
  const f = (b, M) => {
    const N = M - b + 1;
    return Array.from({ length: N }, (_, E) => E + b);
  }, d = Re.useMemo(() => {
    if (n + 5 >= o)
      return f(1, o);
    const M = Math.max(t - n, 1), N = Math.min(t + n, o), _ = M > 2, E = N < o - 2, T = 1, A = o;
    if (!_ && E) {
      const F = 3 + 2 * n;
      return [...f(1, F), "DOTS", o];
    }
    if (_ && !E) {
      const F = 3 + 2 * n, Z = f(o - F + 1, o);
      return [T, "DOTS", ...Z];
    }
    if (_ && E) {
      const F = f(M, N);
      return [T, "DOTS", ...F, "DOTS", A];
    }
    return [];
  }, [o, n, t]);
  if (t === 0 || d.length < 2)
    return null;
  const c = () => {
    t < o && e(t + 1);
  }, x = () => {
    t > 1 && e(t - 1);
  };
  return i ? t >= o ? null : /* @__PURE__ */ r("div", { className: C("flex justify-center", m), ...h, children: /* @__PURE__ */ r(
    ee,
    {
      variant: "secondary",
      onClick: c,
      disabled: a,
      isLoading: a,
      className: C(
        "px-8 py-3 rounded-full",
        "shadow-sm hover:shadow-md",
        "transition-all duration-normal ease-smooth"
      ),
      children: l
    }
  ) }) : s === "floating" ? /* @__PURE__ */ w(
    "nav",
    {
      className: C(
        // Floating container
        "inline-flex items-center justify-center",
        "bg-surface-glass/90 backdrop-blur-md",
        "rounded-full p-1.5",
        "shadow-lg border border-border-subtle/50",
        // Fixed positioning option for floating
        m
      ),
      "aria-label": "Pagination",
      ...h,
      children: [
        /* @__PURE__ */ r(
          "button",
          {
            onClick: x,
            disabled: t === 1,
            className: C(
              "p-2 rounded-full",
              "text-muted-foreground hover:text-foreground hover:bg-surface-secondary",
              "transition-all duration-fast ease-smooth",
              "disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            ),
            "aria-label": "Previous page",
            children: /* @__PURE__ */ r(Ke, { className: "h-4 w-4" })
          }
        ),
        /* @__PURE__ */ r("div", { className: "flex items-center gap-0.5 mx-1", children: d.map((b, M) => {
          if (b === "DOTS")
            return /* @__PURE__ */ r(
              "span",
              {
                className: "w-8 flex items-center justify-center text-muted-foreground",
                children: /* @__PURE__ */ r(ot, { className: "h-4 w-4" })
              },
              `dots-${M}`
            );
          const N = b === t;
          return /* @__PURE__ */ r(
            "button",
            {
              onClick: () => e(Number(b)),
              className: C(
                "min-w-[2rem] h-8 px-2 rounded-full text-sm font-medium",
                "transition-all duration-fast ease-smooth",
                N ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground hover:bg-surface-secondary"
              ),
              "aria-current": N ? "page" : void 0,
              children: b
            },
            b
          );
        }) }),
        /* @__PURE__ */ r(
          "button",
          {
            onClick: c,
            disabled: t === o,
            className: C(
              "p-2 rounded-full",
              "text-muted-foreground hover:text-foreground hover:bg-surface-secondary",
              "transition-all duration-fast ease-smooth",
              "disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            ),
            "aria-label": "Next page",
            children: /* @__PURE__ */ r(De, { className: "h-4 w-4" })
          }
        )
      ]
    }
  ) : s === "minimal" ? /* @__PURE__ */ w(
    "nav",
    {
      className: C("flex items-center justify-center gap-4", m),
      "aria-label": "Pagination",
      ...h,
      children: [
        /* @__PURE__ */ r(
          "button",
          {
            onClick: x,
            disabled: t === 1,
            className: C(
              "p-2 rounded-lg",
              "text-muted-foreground hover:text-foreground hover:bg-surface-secondary",
              "transition-all duration-fast ease-smooth",
              "disabled:opacity-30 disabled:cursor-not-allowed"
            ),
            "aria-label": "Previous page",
            children: /* @__PURE__ */ r(Ke, { className: "h-5 w-5" })
          }
        ),
        /* @__PURE__ */ w("span", { className: "text-sm font-medium text-muted-foreground", children: [
          /* @__PURE__ */ r("span", { className: "text-foreground", children: t }),
          " / ",
          o
        ] }),
        /* @__PURE__ */ r(
          "button",
          {
            onClick: c,
            disabled: t === o,
            className: C(
              "p-2 rounded-lg",
              "text-muted-foreground hover:text-foreground hover:bg-surface-secondary",
              "transition-all duration-fast ease-smooth",
              "disabled:opacity-30 disabled:cursor-not-allowed"
            ),
            "aria-label": "Next page",
            children: /* @__PURE__ */ r(De, { className: "h-5 w-5" })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ w(
    "nav",
    {
      className: C("flex items-center justify-center gap-1", m),
      "aria-label": "Pagination",
      ...h,
      children: [
        /* @__PURE__ */ r(
          ee,
          {
            variant: "ghost",
            size: "sm",
            onClick: x,
            disabled: t === 1,
            className: "rounded-lg",
            leftIcon: /* @__PURE__ */ r(Ke, { className: "h-4 w-4" }),
            children: /* @__PURE__ */ r("span", { className: "sr-only sm:not-sr-only", children: "Previous" })
          }
        ),
        /* @__PURE__ */ r("div", { className: "flex items-center gap-1", children: d.map((b, M) => {
          if (b === "DOTS")
            return /* @__PURE__ */ r(
              "span",
              {
                className: "w-8 flex items-center justify-center text-muted-foreground",
                children: /* @__PURE__ */ r(ot, { className: "h-4 w-4" })
              },
              `dots-${M}`
            );
          const N = b === t;
          return /* @__PURE__ */ r(
            "button",
            {
              onClick: () => e(Number(b)),
              className: C(
                "min-w-[2.25rem] h-9 px-3 rounded-lg text-sm font-medium",
                "transition-all duration-fast ease-smooth",
                N ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground hover:bg-surface-secondary"
              ),
              "aria-current": N ? "page" : void 0,
              children: b
            },
            b
          );
        }) }),
        /* @__PURE__ */ r(
          ee,
          {
            variant: "ghost",
            size: "sm",
            onClick: c,
            disabled: t === o,
            className: "rounded-lg",
            rightIcon: /* @__PURE__ */ r(De, { className: "h-4 w-4" }),
            children: /* @__PURE__ */ r("span", { className: "sr-only sm:not-sr-only", children: "Next" })
          }
        )
      ]
    }
  );
}, Rt = ({
  children: t,
  search: o,
  filters: e,
  actions: n,
  className: s,
  ...i
}) => /* @__PURE__ */ w(
  "div",
  {
    className: C(
      "flex flex-col gap-4 py-4 md:flex-row md:items-center md:justify-between",
      s
    ),
    ...i,
    children: [
      /* @__PURE__ */ w("div", { className: "flex flex-1 items-center gap-4", children: [
        o && /* @__PURE__ */ r("div", { className: "w-full max-w-sm", children: o }),
        e && /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: e }),
        t
      ] }),
      n && /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: n })
    ]
  }
);
var Be = ["Enter", " "], pr = ["ArrowDown", "PageUp", "Home"], kt = ["ArrowUp", "PageDown", "End"], gr = [...pr, ...kt], vr = {
  ltr: [...Be, "ArrowRight"],
  rtl: [...Be, "ArrowLeft"]
}, br = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ce = "Menu", [ye, yr, wr] = Vn(Ce), [ce, Ot] = xt(Ce, [
  wr,
  Ct,
  Et
]), je = Ct(), Tt = Et(), [xr, ue] = ce(Ce), [Nr, Ee] = ce(Ce), At = (t) => {
  const { __scopeMenu: o, open: e = !1, children: n, dir: s, onOpenChange: i, modal: a = !0 } = t, l = je(o), [m, h] = p.useState(null), f = p.useRef(!1), d = Mt(i), c = Hn(s);
  return p.useEffect(() => {
    const x = () => {
      f.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => f.current = !1;
    return document.addEventListener("keydown", x, { capture: !0 }), () => {
      document.removeEventListener("keydown", x, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ r(or, { ...l, children: /* @__PURE__ */ r(
    xr,
    {
      scope: o,
      open: e,
      onOpenChange: d,
      content: m,
      onContentChange: h,
      children: /* @__PURE__ */ r(
        Nr,
        {
          scope: o,
          onClose: p.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: f,
          dir: c,
          modal: a,
          children: n
        }
      )
    }
  ) });
};
At.displayName = Ce;
var Mr = "MenuAnchor", Ye = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, ...n } = t, s = je(e);
    return /* @__PURE__ */ r(Qn, { ...s, ...n, ref: o });
  }
);
Ye.displayName = Mr;
var Xe = "MenuPortal", [Cr, Pt] = ce(Xe, {
  forceMount: void 0
}), zt = (t) => {
  const { __scopeMenu: o, forceMount: e, children: n, container: s } = t, i = ue(Xe, o);
  return /* @__PURE__ */ r(Cr, { scope: o, forceMount: e, children: /* @__PURE__ */ r(Le, { present: e || i.open, children: /* @__PURE__ */ r(Zn, { asChild: !0, container: s, children: n }) }) });
};
zt.displayName = Xe;
var H = "MenuContent", [Er, qe] = ce(H), Ft = p.forwardRef(
  (t, o) => {
    const e = Pt(H, t.__scopeMenu), { forceMount: n = e.forceMount, ...s } = t, i = ue(H, t.__scopeMenu), a = Ee(H, t.__scopeMenu);
    return /* @__PURE__ */ r(ye.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ r(Le, { present: n || i.open, children: /* @__PURE__ */ r(ye.Slot, { scope: t.__scopeMenu, children: a.modal ? /* @__PURE__ */ r(Sr, { ...s, ref: o }) : /* @__PURE__ */ r(_r, { ...s, ref: o }) }) }) });
  }
), Sr = p.forwardRef(
  (t, o) => {
    const e = ue(H, t.__scopeMenu), n = p.useRef(null), s = Me(o, n);
    return p.useEffect(() => {
      const i = n.current;
      if (i) return sr(i);
    }, []), /* @__PURE__ */ r(
      He,
      {
        ...t,
        ref: s,
        trapFocus: e.open,
        disableOutsidePointerEvents: e.open,
        disableOutsideScroll: !0,
        onFocusOutside: O(
          t.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => e.onOpenChange(!1)
      }
    );
  }
), _r = p.forwardRef((t, o) => {
  const e = ue(H, t.__scopeMenu);
  return /* @__PURE__ */ r(
    He,
    {
      ...t,
      ref: o,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => e.onOpenChange(!1)
    }
  );
}), Ir = Yn("MenuContent.ScrollLock"), He = p.forwardRef(
  (t, o) => {
    const {
      __scopeMenu: e,
      loop: n = !1,
      trapFocus: s,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: l,
      onEntryFocus: m,
      onEscapeKeyDown: h,
      onPointerDownOutside: f,
      onFocusOutside: d,
      onInteractOutside: c,
      onDismiss: x,
      disableOutsideScroll: b,
      ...M
    } = t, N = ue(H, e), _ = Ee(H, e), E = je(e), T = Tt(e), A = yr(e), [F, Z] = p.useState(null), J = p.useRef(null), ae = Me(o, J, N.onContentChange), te = p.useRef(0), P = p.useRef(""), ne = p.useRef(0), oe = p.useRef(null), le = p.useRef("right"), K = p.useRef(0), ge = b ? tr : p.Fragment, he = b ? { as: Ir, allowPinchZoom: !0 } : void 0, U = (y) => {
      var g, I;
      const L = P.current + y, W = A().filter((D) => !D.disabled), Y = document.activeElement, ie = (g = W.find((D) => D.ref.current === Y)) == null ? void 0 : g.textValue, X = W.map((D) => D.textValue), Q = $r(X, L, ie), B = (I = W.find((D) => D.textValue === Q)) == null ? void 0 : I.ref.current;
      (function D(S) {
        P.current = S, window.clearTimeout(te.current), S !== "" && (te.current = window.setTimeout(() => D(""), 1e3));
      })(L), B && setTimeout(() => B.focus());
    };
    p.useEffect(() => () => window.clearTimeout(te.current), []), er();
    const V = p.useCallback((y) => {
      var W, Y;
      return le.current === ((W = oe.current) == null ? void 0 : W.side) && Gr(y, (Y = oe.current) == null ? void 0 : Y.area);
    }, []);
    return /* @__PURE__ */ r(
      Er,
      {
        scope: e,
        searchRef: P,
        onItemEnter: p.useCallback(
          (y) => {
            V(y) && y.preventDefault();
          },
          [V]
        ),
        onItemLeave: p.useCallback(
          (y) => {
            var L;
            V(y) || ((L = J.current) == null || L.focus(), Z(null));
          },
          [V]
        ),
        onTriggerLeave: p.useCallback(
          (y) => {
            V(y) && y.preventDefault();
          },
          [V]
        ),
        pointerGraceTimerRef: ne,
        onPointerGraceIntentChange: p.useCallback((y) => {
          oe.current = y;
        }, []),
        children: /* @__PURE__ */ r(ge, { ...he, children: /* @__PURE__ */ r(
          nr,
          {
            asChild: !0,
            trapped: s,
            onMountAutoFocus: O(i, (y) => {
              var L;
              y.preventDefault(), (L = J.current) == null || L.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ r(
              Jn,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: h,
                onPointerDownOutside: f,
                onFocusOutside: d,
                onInteractOutside: c,
                onDismiss: x,
                children: /* @__PURE__ */ r(
                  lr,
                  {
                    asChild: !0,
                    ...T,
                    dir: _.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: F,
                    onCurrentTabStopIdChange: Z,
                    onEntryFocus: O(m, (y) => {
                      _.isUsingKeyboardRef.current || y.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ r(
                      rr,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Qt(N.open),
                        "data-radix-menu-content": "",
                        dir: _.dir,
                        ...E,
                        ...M,
                        ref: ae,
                        style: { outline: "none", ...M.style },
                        onKeyDown: O(M.onKeyDown, (y) => {
                          const W = y.target.closest("[data-radix-menu-content]") === y.currentTarget, Y = y.ctrlKey || y.altKey || y.metaKey, ie = y.key.length === 1;
                          W && (y.key === "Tab" && y.preventDefault(), !Y && ie && U(y.key));
                          const X = J.current;
                          if (y.target !== X || !gr.includes(y.key)) return;
                          y.preventDefault();
                          const B = A().filter((g) => !g.disabled).map((g) => g.ref.current);
                          kt.includes(y.key) && B.reverse(), Lr(B);
                        }),
                        onBlur: O(t.onBlur, (y) => {
                          y.currentTarget.contains(y.target) || (window.clearTimeout(te.current), P.current = "");
                        }),
                        onPointerMove: O(
                          t.onPointerMove,
                          we((y) => {
                            const L = y.target, W = K.current !== y.clientX;
                            if (y.currentTarget.contains(L) && W) {
                              const Y = y.clientX > K.current ? "right" : "left";
                              le.current = Y, K.current = y.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ft.displayName = H;
var Dr = "MenuGroup", Ze = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, ...n } = t;
    return /* @__PURE__ */ r(pe.div, { role: "group", ...n, ref: o });
  }
);
Ze.displayName = Dr;
var Rr = "MenuLabel", Lt = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, ...n } = t;
    return /* @__PURE__ */ r(pe.div, { ...n, ref: o });
  }
);
Lt.displayName = Rr;
var Te = "MenuItem", at = "menu.itemSelect", $e = p.forwardRef(
  (t, o) => {
    const { disabled: e = !1, onSelect: n, ...s } = t, i = p.useRef(null), a = Ee(Te, t.__scopeMenu), l = qe(Te, t.__scopeMenu), m = Me(o, i), h = p.useRef(!1), f = () => {
      const d = i.current;
      if (!e && d) {
        const c = new CustomEvent(at, { bubbles: !0, cancelable: !0 });
        d.addEventListener(at, (x) => n == null ? void 0 : n(x), { once: !0 }), Xn(d, c), c.defaultPrevented ? h.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ r(
      jt,
      {
        ...s,
        ref: m,
        disabled: e,
        onClick: O(t.onClick, f),
        onPointerDown: (d) => {
          var c;
          (c = t.onPointerDown) == null || c.call(t, d), h.current = !0;
        },
        onPointerUp: O(t.onPointerUp, (d) => {
          var c;
          h.current || (c = d.currentTarget) == null || c.click();
        }),
        onKeyDown: O(t.onKeyDown, (d) => {
          const c = l.searchRef.current !== "";
          e || c && d.key === " " || Be.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
$e.displayName = Te;
var jt = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, disabled: n = !1, textValue: s, ...i } = t, a = qe(Te, e), l = Tt(e), m = p.useRef(null), h = Me(o, m), [f, d] = p.useState(!1), [c, x] = p.useState("");
    return p.useEffect(() => {
      const b = m.current;
      b && x((b.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ r(
      ye.ItemSlot,
      {
        scope: e,
        disabled: n,
        textValue: s ?? c,
        children: /* @__PURE__ */ r(ar, { asChild: !0, ...l, focusable: !n, children: /* @__PURE__ */ r(
          pe.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...i,
            ref: h,
            onPointerMove: O(
              t.onPointerMove,
              we((b) => {
                n ? a.onItemLeave(b) : (a.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: O(
              t.onPointerLeave,
              we((b) => a.onItemLeave(b))
            ),
            onFocus: O(t.onFocus, () => d(!0)),
            onBlur: O(t.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), kr = "MenuCheckboxItem", $t = p.forwardRef(
  (t, o) => {
    const { checked: e = !1, onCheckedChange: n, ...s } = t;
    return /* @__PURE__ */ r(Ut, { scope: t.__scopeMenu, checked: e, children: /* @__PURE__ */ r(
      $e,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ae(e) ? "mixed" : e,
        ...s,
        ref: o,
        "data-state": Qe(e),
        onSelect: O(
          s.onSelect,
          () => n == null ? void 0 : n(Ae(e) ? !0 : !e),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
$t.displayName = kr;
var Wt = "MenuRadioGroup", [Or, Tr] = ce(
  Wt,
  { value: void 0, onValueChange: () => {
  } }
), Gt = p.forwardRef(
  (t, o) => {
    const { value: e, onValueChange: n, ...s } = t, i = Mt(n);
    return /* @__PURE__ */ r(Or, { scope: t.__scopeMenu, value: e, onValueChange: i, children: /* @__PURE__ */ r(Ze, { ...s, ref: o }) });
  }
);
Gt.displayName = Wt;
var Kt = "MenuRadioItem", Bt = p.forwardRef(
  (t, o) => {
    const { value: e, ...n } = t, s = Tr(Kt, t.__scopeMenu), i = e === s.value;
    return /* @__PURE__ */ r(Ut, { scope: t.__scopeMenu, checked: i, children: /* @__PURE__ */ r(
      $e,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...n,
        ref: o,
        "data-state": Qe(i),
        onSelect: O(
          n.onSelect,
          () => {
            var a;
            return (a = s.onValueChange) == null ? void 0 : a.call(s, e);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Bt.displayName = Kt;
var Je = "MenuItemIndicator", [Ut, Ar] = ce(
  Je,
  { checked: !1 }
), Vt = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, forceMount: n, ...s } = t, i = Ar(Je, e);
    return /* @__PURE__ */ r(
      Le,
      {
        present: n || Ae(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ r(
          pe.span,
          {
            ...s,
            ref: o,
            "data-state": Qe(i.checked)
          }
        )
      }
    );
  }
);
Vt.displayName = Je;
var Pr = "MenuSeparator", Yt = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, ...n } = t;
    return /* @__PURE__ */ r(
      pe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: o
      }
    );
  }
);
Yt.displayName = Pr;
var zr = "MenuArrow", Xt = p.forwardRef(
  (t, o) => {
    const { __scopeMenu: e, ...n } = t, s = je(e);
    return /* @__PURE__ */ r(ir, { ...s, ...n, ref: o });
  }
);
Xt.displayName = zr;
var Fr = "MenuSub", [lo, qt] = ce(Fr), ve = "MenuSubTrigger", Ht = p.forwardRef(
  (t, o) => {
    const e = ue(ve, t.__scopeMenu), n = Ee(ve, t.__scopeMenu), s = qt(ve, t.__scopeMenu), i = qe(ve, t.__scopeMenu), a = p.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: m } = i, h = { __scopeMenu: t.__scopeMenu }, f = p.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return p.useEffect(() => f, [f]), p.useEffect(() => {
      const d = l.current;
      return () => {
        window.clearTimeout(d), m(null);
      };
    }, [l, m]), /* @__PURE__ */ r(Ye, { asChild: !0, ...h, children: /* @__PURE__ */ r(
      jt,
      {
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": e.open,
        "aria-controls": s.contentId,
        "data-state": Qt(e.open),
        ...t,
        ref: Nt(o, s.onTriggerChange),
        onClick: (d) => {
          var c;
          (c = t.onClick) == null || c.call(t, d), !(t.disabled || d.defaultPrevented) && (d.currentTarget.focus(), e.open || e.onOpenChange(!0));
        },
        onPointerMove: O(
          t.onPointerMove,
          we((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !t.disabled && !e.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              e.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: O(
          t.onPointerLeave,
          we((d) => {
            var x, b;
            f();
            const c = (x = e.content) == null ? void 0 : x.getBoundingClientRect();
            if (c) {
              const M = (b = e.content) == null ? void 0 : b.dataset.side, N = M === "right", _ = N ? -5 : 5, E = c[N ? "left" : "right"], T = c[N ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + _, y: d.clientY },
                  { x: E, y: c.top },
                  { x: T, y: c.top },
                  { x: T, y: c.bottom },
                  { x: E, y: c.bottom }
                ],
                side: M
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: O(t.onKeyDown, (d) => {
          var x;
          const c = i.searchRef.current !== "";
          t.disabled || c && d.key === " " || vr[n.dir].includes(d.key) && (e.onOpenChange(!0), (x = e.content) == null || x.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Ht.displayName = ve;
var Zt = "MenuSubContent", Jt = p.forwardRef(
  (t, o) => {
    const e = Pt(H, t.__scopeMenu), { forceMount: n = e.forceMount, ...s } = t, i = ue(H, t.__scopeMenu), a = Ee(H, t.__scopeMenu), l = qt(Zt, t.__scopeMenu), m = p.useRef(null), h = Me(o, m);
    return /* @__PURE__ */ r(ye.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ r(Le, { present: n || i.open, children: /* @__PURE__ */ r(ye.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ r(
      He,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...s,
        ref: h,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var d;
          a.isUsingKeyboardRef.current && ((d = m.current) == null || d.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: O(t.onFocusOutside, (f) => {
          f.target !== l.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: O(t.onEscapeKeyDown, (f) => {
          a.onClose(), f.preventDefault();
        }),
        onKeyDown: O(t.onKeyDown, (f) => {
          var x;
          const d = f.currentTarget.contains(f.target), c = br[a.dir].includes(f.key);
          d && c && (i.onOpenChange(!1), (x = l.trigger) == null || x.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
Jt.displayName = Zt;
function Qt(t) {
  return t ? "open" : "closed";
}
function Ae(t) {
  return t === "indeterminate";
}
function Qe(t) {
  return Ae(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function Lr(t) {
  const o = document.activeElement;
  for (const e of t)
    if (e === o || (e.focus(), document.activeElement !== o)) return;
}
function jr(t, o) {
  return t.map((e, n) => t[(o + n) % t.length]);
}
function $r(t, o, e) {
  const s = o.length > 1 && Array.from(o).every((h) => h === o[0]) ? o[0] : o, i = e ? t.indexOf(e) : -1;
  let a = jr(t, Math.max(i, 0));
  s.length === 1 && (a = a.filter((h) => h !== e));
  const m = a.find(
    (h) => h.toLowerCase().startsWith(s.toLowerCase())
  );
  return m !== e ? m : void 0;
}
function Wr(t, o) {
  const { x: e, y: n } = t;
  let s = !1;
  for (let i = 0, a = o.length - 1; i < o.length; a = i++) {
    const l = o[i], m = o[a], h = l.x, f = l.y, d = m.x, c = m.y;
    f > n != c > n && e < (d - h) * (n - f) / (c - f) + h && (s = !s);
  }
  return s;
}
function Gr(t, o) {
  if (!o) return !1;
  const e = { x: t.clientX, y: t.clientY };
  return Wr(e, o);
}
function we(t) {
  return (o) => o.pointerType === "mouse" ? t(o) : void 0;
}
var Kr = At, Br = Ye, Ur = zt, Vr = Ft, Yr = Ze, Xr = Lt, qr = $e, Hr = $t, Zr = Gt, Jr = Bt, Qr = Vt, es = Yt, ts = Xt, ns = Ht, rs = Jt, We = "DropdownMenu", [ss] = xt(
  We,
  [Ot]
), G = Ot(), [os, en] = ss(We), tn = (t) => {
  const {
    __scopeDropdownMenu: o,
    children: e,
    dir: n,
    open: s,
    defaultOpen: i,
    onOpenChange: a,
    modal: l = !0
  } = t, m = G(o), h = p.useRef(null), [f, d] = qn({
    prop: s,
    defaultProp: i ?? !1,
    onChange: a,
    caller: We
  });
  return /* @__PURE__ */ r(
    os,
    {
      scope: o,
      triggerId: it(),
      triggerRef: h,
      contentId: it(),
      open: f,
      onOpenChange: d,
      onOpenToggle: p.useCallback(() => d((c) => !c), [d]),
      modal: l,
      children: /* @__PURE__ */ r(Kr, { ...m, open: f, onOpenChange: d, dir: n, modal: l, children: e })
    }
  );
};
tn.displayName = We;
var nn = "DropdownMenuTrigger", rn = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, disabled: n = !1, ...s } = t, i = en(nn, e), a = G(e);
    return /* @__PURE__ */ r(Br, { asChild: !0, ...a, children: /* @__PURE__ */ r(
      pe.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...s,
        ref: Nt(o, i.triggerRef),
        onPointerDown: O(t.onPointerDown, (l) => {
          !n && l.button === 0 && l.ctrlKey === !1 && (i.onOpenToggle(), i.open || l.preventDefault());
        }),
        onKeyDown: O(t.onKeyDown, (l) => {
          n || (["Enter", " "].includes(l.key) && i.onOpenToggle(), l.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
        })
      }
    ) });
  }
);
rn.displayName = nn;
var is = "DropdownMenuPortal", sn = (t) => {
  const { __scopeDropdownMenu: o, ...e } = t, n = G(o);
  return /* @__PURE__ */ r(Ur, { ...n, ...e });
};
sn.displayName = is;
var on = "DropdownMenuContent", an = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, ...n } = t, s = en(on, e), i = G(e), a = p.useRef(!1);
    return /* @__PURE__ */ r(
      Vr,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...i,
        ...n,
        ref: o,
        onCloseAutoFocus: O(t.onCloseAutoFocus, (l) => {
          var m;
          a.current || (m = s.triggerRef.current) == null || m.focus(), a.current = !1, l.preventDefault();
        }),
        onInteractOutside: O(t.onInteractOutside, (l) => {
          const m = l.detail.originalEvent, h = m.button === 0 && m.ctrlKey === !0, f = m.button === 2 || h;
          (!s.modal || f) && (a.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
an.displayName = on;
var as = "DropdownMenuGroup", ls = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
    return /* @__PURE__ */ r(Yr, { ...s, ...n, ref: o });
  }
);
ls.displayName = as;
var ds = "DropdownMenuLabel", ln = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
    return /* @__PURE__ */ r(Xr, { ...s, ...n, ref: o });
  }
);
ln.displayName = ds;
var cs = "DropdownMenuItem", dn = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
    return /* @__PURE__ */ r(qr, { ...s, ...n, ref: o });
  }
);
dn.displayName = cs;
var us = "DropdownMenuCheckboxItem", cn = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(Hr, { ...s, ...n, ref: o });
});
cn.displayName = us;
var hs = "DropdownMenuRadioGroup", fs = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(Zr, { ...s, ...n, ref: o });
});
fs.displayName = hs;
var ms = "DropdownMenuRadioItem", un = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(Jr, { ...s, ...n, ref: o });
});
un.displayName = ms;
var ps = "DropdownMenuItemIndicator", hn = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(Qr, { ...s, ...n, ref: o });
});
hn.displayName = ps;
var gs = "DropdownMenuSeparator", fn = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(es, { ...s, ...n, ref: o });
});
fn.displayName = gs;
var vs = "DropdownMenuArrow", bs = p.forwardRef(
  (t, o) => {
    const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
    return /* @__PURE__ */ r(ts, { ...s, ...n, ref: o });
  }
);
bs.displayName = vs;
var ys = "DropdownMenuSubTrigger", mn = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(ns, { ...s, ...n, ref: o });
});
mn.displayName = ys;
var ws = "DropdownMenuSubContent", pn = p.forwardRef((t, o) => {
  const { __scopeDropdownMenu: e, ...n } = t, s = G(e);
  return /* @__PURE__ */ r(
    rs,
    {
      ...s,
      ...n,
      ref: o,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
pn.displayName = ws;
var xs = tn, Ns = rn, Ms = sn, gn = an, vn = ln, bn = dn, yn = cn, wn = un, xn = hn, Nn = fn, Mn = mn, Cn = pn;
const Pe = xs, ze = Ns, Cs = p.forwardRef(({ className: t, inset: o, children: e, ...n }, s) => /* @__PURE__ */ w(
  Mn,
  {
    ref: s,
    className: C(
      "flex cursor-default select-none items-center rounded-[var(--ds-radius-sm)] px-2 py-1.5 text-sm outline-none focus:bg-[var(--ds-color-bg-surface-hover)] data-[state=open]:bg-[var(--ds-color-bg-surface-hover)]",
      o && "ps-8",
      t
    ),
    ...n,
    children: [
      e,
      /* @__PURE__ */ r(De, { className: "ms-auto h-4 w-4" })
    ]
  }
));
Cs.displayName = Mn.displayName;
const Es = p.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ r(
  Cn,
  {
    ref: e,
    className: C(
      "z-50 min-w-[8rem] overflow-hidden rounded-[var(--ds-radius-md)] border bg-[var(--ds-color-bg-surface-default)] p-1 text-[var(--ds-color-fg-default)] shadow-elevation-3 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...o
  }
));
Es.displayName = Cn.displayName;
const xe = p.forwardRef(({ className: t, sideOffset: o = 4, ...e }, n) => /* @__PURE__ */ r(Ms, { children: /* @__PURE__ */ r(
  gn,
  {
    ref: n,
    sideOffset: o,
    className: C(
      "z-50 min-w-[8rem] overflow-hidden rounded-[var(--ds-radius-md)] border bg-[var(--ds-color-bg-surface-default)] p-1 text-[var(--ds-color-fg-default)] shadow-elevation-2 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...e
  }
) }));
xe.displayName = gn.displayName;
const Ss = p.forwardRef(({ className: t, inset: o, ...e }, n) => /* @__PURE__ */ r(
  bn,
  {
    ref: n,
    className: C(
      "relative flex cursor-default select-none items-center rounded-[var(--ds-radius-sm)] px-2 py-1.5 text-sm outline-none transition-colors focus:bg-[var(--ds-color-bg-surface-hover)] focus:text-[var(--ds-color-fg-default)] data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      o && "ps-8",
      t
    ),
    ...e
  }
));
Ss.displayName = bn.displayName;
const et = p.forwardRef(({ className: t, children: o, checked: e, ...n }, s) => /* @__PURE__ */ w(
  yn,
  {
    ref: s,
    className: C(
      "relative flex cursor-default select-none items-center rounded-[var(--ds-radius-sm)] py-1.5 ps-8 pe-2 text-sm outline-none transition-colors focus:bg-[var(--ds-color-bg-surface-hover)] focus:text-[var(--ds-color-fg-default)] data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: e,
    ...n,
    children: [
      /* @__PURE__ */ r("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center rtl:right-2 rtl:left-auto", children: /* @__PURE__ */ r(xn, { children: /* @__PURE__ */ r(dr, { className: "h-4 w-4" }) }) }),
      o
    ]
  }
));
et.displayName = yn.displayName;
const _s = p.forwardRef(({ className: t, children: o, ...e }, n) => /* @__PURE__ */ w(
  wn,
  {
    ref: n,
    className: C(
      "relative flex cursor-default select-none items-center rounded-[var(--ds-radius-sm)] py-1.5 ps-8 pe-2 text-sm outline-none transition-colors focus:bg-[var(--ds-color-bg-surface-hover)] focus:text-[var(--ds-color-fg-default)] data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...e,
    children: [
      /* @__PURE__ */ r("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center rtl:right-2 rtl:left-auto", children: /* @__PURE__ */ r(xn, { children: /* @__PURE__ */ r(Bn, { className: "h-2 w-2 fill-current" }) }) }),
      o
    ]
  }
));
_s.displayName = wn.displayName;
const Ne = p.forwardRef(({ className: t, inset: o, ...e }, n) => /* @__PURE__ */ r(
  vn,
  {
    ref: n,
    className: C(
      "px-2 py-1.5 text-sm font-semibold",
      o && "ps-8",
      t
    ),
    ...e
  }
));
Ne.displayName = vn.displayName;
const de = p.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ r(
  Nn,
  {
    ref: e,
    className: C("-mx-1 my-1 h-px bg-[var(--ds-color-border-muted)]", t),
    ...o
  }
));
de.displayName = Nn.displayName;
const co = ({
  pagination: t,
  toolbar: o,
  className: e,
  bulkActions: n,
  showColumnVisibility: s,
  onColumnVisibilityChange: i,
  savedViews: a,
  showSavedViews: l,
  ...m
}) => {
  const h = m.selected && m.selected.size > 0, [f, d] = pt(""), c = (N, _) => {
    i && i({
      ...m.columnVisibility,
      [N]: _
    });
  }, x = () => /* @__PURE__ */ w(Pe, { children: [
    /* @__PURE__ */ r(ze, { asChild: !0, children: /* @__PURE__ */ w(ee, { variant: "outline", size: "sm", className: "h-8 gap-1 ml-auto", children: [
      /* @__PURE__ */ r(wt, { className: "h-4 w-4" }),
      /* @__PURE__ */ r("span", { className: "hidden sm:inline", children: "Columns" })
    ] }) }),
    /* @__PURE__ */ w(xe, { align: "end", className: "w-[150px]", children: [
      /* @__PURE__ */ r(Ne, { children: "Toggle Columns" }),
      /* @__PURE__ */ r(de, {}),
      m.columns.map((N) => {
        var _;
        return /* @__PURE__ */ r(
          et,
          {
            className: "capitalize",
            checked: ((_ = m.columnVisibility) == null ? void 0 : _[N.key]) !== !1,
            onCheckedChange: (E) => c(N.key, E),
            children: N.header
          },
          N.key
        );
      })
    ] })
  ] }), M = /* @__PURE__ */ w(se, { children: [
    l && (a ? /* @__PURE__ */ w(Pe, { children: [
      /* @__PURE__ */ r(ze, { asChild: !0, children: /* @__PURE__ */ w(ee, { variant: "outline", size: "sm", className: "h-8 gap-1", children: [
        /* @__PURE__ */ r(_t, { className: "h-4 w-4" }),
        /* @__PURE__ */ r("span", { className: "hidden sm:inline", children: "Views" })
      ] }) }),
      /* @__PURE__ */ w(xe, { align: "end", className: "w-[200px]", children: [
        /* @__PURE__ */ r(Ne, { children: "Saved Views" }),
        /* @__PURE__ */ r(de, {}),
        a.views.length === 0 ? /* @__PURE__ */ r("div", { className: "p-2 text-sm text-muted-foreground", children: "No saved views" }) : a.views.map((N) => /* @__PURE__ */ w("div", { className: "flex items-center justify-between px-2 py-1.5 hover:bg-accent hover:text-accent-foreground rounded-[var(--ds-radius-sm)] cursor-pointer group", children: [
          /* @__PURE__ */ r("div", { className: "flex-1 text-sm", onClick: () => a.onLoad(N), children: N.name }),
          /* @__PURE__ */ r(
            "button",
            {
              onClick: (_) => {
                _.stopPropagation(), a.onDelete(N.id);
              },
              className: "opacity-0 group-hover:opacity-100 p-1 hover:bg-destructive/10 text-destructive rounded-[var(--ds-radius-sm)]",
              children: /* @__PURE__ */ r(It, { className: "h-3 w-3" })
            }
          )
        ] }, N.id)),
        /* @__PURE__ */ r(de, {}),
        /* @__PURE__ */ r("div", { className: "p-2", children: /* @__PURE__ */ w(
          "form",
          {
            onSubmit: (N) => {
              N.preventDefault(), f.trim() && (a.onSave(f), d(""));
            },
            className: "flex gap-2",
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  className: "flex h-7 w-full rounded-[var(--ds-radius-md)] border border-input bg-transparent px-2 py-1 text-sm shadow-elevation-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                  placeholder: "New view name...",
                  value: f,
                  onChange: (N) => d(N.target.value)
                }
              ),
              /* @__PURE__ */ r(ee, { type: "submit", size: "sm", className: "h-7 px-2", disabled: !f.trim(), children: /* @__PURE__ */ r(yt, { className: "h-3 w-3" }) })
            ]
          }
        ) })
      ] })
    ] }) : null),
    s && x(),
    o == null ? void 0 : o.actions
  ] });
  return /* @__PURE__ */ w("div", { className: C("flex flex-col gap-4", e), children: [
    o && /* @__PURE__ */ r(
      Rt,
      {
        search: h ? void 0 : o.search,
        filters: h ? void 0 : o.filters,
        actions: h && n ? n : M,
        children: h ? /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ w(Oe, { variant: "small", className: "font-medium text-primary", children: [
          m.selected.size,
          " selected"
        ] }) }) : o.children
      }
    ),
    /* @__PURE__ */ r(mr, { ...m }),
    t && /* @__PURE__ */ r("div", { className: "flex items-center justify-end py-4", children: /* @__PURE__ */ r(Dt, { ...t }) })
  ] });
};
function me(t, o, e) {
  let n = e.initialDeps ?? [], s, i = !0;
  function a() {
    var l, m, h;
    let f;
    e.key && ((l = e.debug) != null && l.call(e)) && (f = Date.now());
    const d = t();
    if (!(d.length !== n.length || d.some((b, M) => n[M] !== b)))
      return s;
    n = d;
    let x;
    if (e.key && ((m = e.debug) != null && m.call(e)) && (x = Date.now()), s = o(...d), e.key && ((h = e.debug) != null && h.call(e))) {
      const b = Math.round((Date.now() - f) * 100) / 100, M = Math.round((Date.now() - x) * 100) / 100, N = M / 16, _ = (E, T) => {
        for (E = String(E); E.length < T; )
          E = " " + E;
        return E;
      };
      console.info(
        `%c⏱ ${_(M, 5)} /${_(b, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * N, 120)
        )}deg 100% 31%);`,
        e == null ? void 0 : e.key
      );
    }
    return e != null && e.onChange && !(i && e.skipInitialOnChange) && e.onChange(s), i = !1, s;
  }
  return a.updateDeps = (l) => {
    n = l;
  }, a;
}
function lt(t, o) {
  if (t === void 0)
    throw new Error("Unexpected undefined");
  return t;
}
const Is = (t, o) => Math.abs(t - o) < 1.01, Ds = (t, o, e) => {
  let n;
  return function(...s) {
    t.clearTimeout(n), n = t.setTimeout(() => o.apply(this, s), e);
  };
}, dt = (t) => {
  const { offsetWidth: o, offsetHeight: e } = t;
  return { width: o, height: e };
}, Rs = (t) => t, ks = (t) => {
  const o = Math.max(t.startIndex - t.overscan, 0), e = Math.min(t.endIndex + t.overscan, t.count - 1), n = [];
  for (let s = o; s <= e; s++)
    n.push(s);
  return n;
}, Os = (t, o) => {
  const e = t.scrollElement;
  if (!e)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  const s = (a) => {
    const { width: l, height: m } = a;
    o({ width: Math.round(l), height: Math.round(m) });
  };
  if (s(dt(e)), !n.ResizeObserver)
    return () => {
    };
  const i = new n.ResizeObserver((a) => {
    const l = () => {
      const m = a[0];
      if (m != null && m.borderBoxSize) {
        const h = m.borderBoxSize[0];
        if (h) {
          s({ width: h.inlineSize, height: h.blockSize });
          return;
        }
      }
      s(dt(e));
    };
    t.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(l) : l();
  });
  return i.observe(e, { box: "border-box" }), () => {
    i.unobserve(e);
  };
}, ct = {
  passive: !0
}, ut = typeof window > "u" ? !0 : "onscrollend" in window, Ts = (t, o) => {
  const e = t.scrollElement;
  if (!e)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  let s = 0;
  const i = t.options.useScrollendEvent && ut ? () => {
  } : Ds(
    n,
    () => {
      o(s, !1);
    },
    t.options.isScrollingResetDelay
  ), a = (f) => () => {
    const { horizontal: d, isRtl: c } = t.options;
    s = d ? e.scrollLeft * (c && -1 || 1) : e.scrollTop, i(), o(s, f);
  }, l = a(!0), m = a(!1);
  e.addEventListener("scroll", l, ct);
  const h = t.options.useScrollendEvent && ut;
  return h && e.addEventListener("scrollend", m, ct), () => {
    e.removeEventListener("scroll", l), h && e.removeEventListener("scrollend", m);
  };
}, As = (t, o, e) => {
  if (o != null && o.borderBoxSize) {
    const n = o.borderBoxSize[0];
    if (n)
      return Math.round(
        n[e.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return t[e.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, Ps = (t, {
  adjustments: o = 0,
  behavior: e
}, n) => {
  var s, i;
  const a = t + o;
  (i = (s = n.scrollElement) == null ? void 0 : s.scrollTo) == null || i.call(s, {
    [n.options.horizontal ? "left" : "top"]: a,
    behavior: e
  });
};
class zs {
  constructor(o) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let e = null;
      const n = () => e || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : e = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((i) => {
          const a = () => {
            this._measureElement(i.target, i);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = n()) == null || s.disconnect(), e = null;
        },
        observe: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (e) => {
      Object.entries(e).forEach(([n, s]) => {
        typeof s > "u" && delete e[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Rs,
        rangeExtractor: ks,
        onChange: () => {
        },
        measureElement: As,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...e
      };
    }, this.notify = (e) => {
      var n, s;
      (s = (n = this.options).onChange) == null || s.call(n, this, e);
    }, this.maybeNotify = me(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (e) => {
        this.notify(e);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((e) => e()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var e;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((e = this.scrollElement) == null ? void 0 : e.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = i, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (e, n) => {
      const s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = n - 1; a >= 0; a--) {
        const l = e[a];
        if (s.has(l.lane))
          continue;
        const m = i.get(
          l.lane
        );
        if (m == null || l.end > m.end ? i.set(l.lane, l) : l.end < m.end && s.set(l.lane, !0), s.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, l) => a.end === l.end ? a.index - l.index : a.end - l.end)[0] : void 0;
    }, this.getMeasurementOptions = me(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (e, n, s, i, a, l) => (this.prevLanes !== void 0 && this.prevLanes !== l && (this.lanesChangedFlag = !0), this.prevLanes = l, this.pendingMeasuredCacheIndexes = [], {
        count: e,
        paddingStart: n,
        scrollMargin: s,
        getItemKey: i,
        enabled: a,
        lanes: l
      }),
      {
        key: !1
      }
    ), this.getMeasurements = me(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: e, paddingStart: n, scrollMargin: s, getItemKey: i, enabled: a, lanes: l }, m) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > e)
          for (const c of this.laneAssignments.keys())
            c >= e && this.laneAssignments.delete(c);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((c) => {
          this.itemSizeCache.set(c.key, c.size);
        }));
        const h = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === e && (this.lanesSettling = !1);
        const f = this.measurementsCache.slice(0, h), d = new Array(l).fill(
          void 0
        );
        for (let c = 0; c < h; c++) {
          const x = f[c];
          x && (d[x.lane] = c);
        }
        for (let c = h; c < e; c++) {
          const x = i(c), b = this.laneAssignments.get(c);
          let M, N;
          if (b !== void 0 && this.options.lanes > 1) {
            M = b;
            const A = d[M], F = A !== void 0 ? f[A] : void 0;
            N = F ? F.end + this.options.gap : n + s;
          } else {
            const A = this.options.lanes === 1 ? f[c - 1] : this.getFurthestMeasurement(f, c);
            N = A ? A.end + this.options.gap : n + s, M = A ? A.lane : c % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(c, M);
          }
          const _ = m.get(x), E = typeof _ == "number" ? _ : this.options.estimateSize(c), T = N + E;
          f[c] = {
            index: c,
            start: N,
            size: E,
            end: T,
            key: x,
            lane: M
          }, d[M] = c;
        }
        return this.measurementsCache = f, f;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = me(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (e, n, s, i) => this.range = e.length > 0 && n > 0 ? Fs({
        measurements: e,
        outerSize: n,
        scrollOffset: s,
        lanes: i
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = me(
      () => {
        let e = null, n = null;
        const s = this.calculateRange();
        return s && (e = s.startIndex, n = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, e, n]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          e,
          n
        ];
      },
      (e, n, s, i, a) => i === null || a === null ? [] : e({
        startIndex: i,
        endIndex: a,
        overscan: n,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (e) => {
      const n = this.options.indexAttribute, s = e.getAttribute(n);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (e, n) => {
      const s = this.indexFromElement(e), i = this.measurementsCache[s];
      if (!i)
        return;
      const a = i.key, l = this.elementsCache.get(a);
      l !== e && (l && this.observer.unobserve(l), this.observer.observe(e), this.elementsCache.set(a, e)), e.isConnected && this.resizeItem(s, this.options.measureElement(e, n, this));
    }, this.resizeItem = (e, n) => {
      const s = this.measurementsCache[e];
      if (!s)
        return;
      const i = this.itemSizeCache.get(s.key) ?? s.size, a = n - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, n)), this.notify(!1));
    }, this.measureElement = (e) => {
      if (!e) {
        this.elementsCache.forEach((n, s) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(e, void 0);
    }, this.getVirtualItems = me(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (e, n) => {
        const s = [];
        for (let i = 0, a = e.length; i < a; i++) {
          const l = e[i], m = n[l];
          s.push(m);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (e) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return lt(
          n[En(
            0,
            n.length - 1,
            (s) => lt(n[s]).start,
            e
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const e = this.scrollElement.document.documentElement;
        return this.options.horizontal ? e.scrollWidth - this.scrollElement.innerWidth : e.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (e, n, s = 0) => {
      if (!this.scrollElement) return 0;
      const i = this.getSize(), a = this.getScrollOffset();
      n === "auto" && (n = e >= a + i ? "end" : "start"), n === "center" ? e += (s - i) / 2 : n === "end" && (e -= i);
      const l = this.getMaxScrollOffset();
      return Math.max(Math.min(l, e), 0);
    }, this.getOffsetForIndex = (e, n = "auto") => {
      e = Math.max(0, Math.min(e, this.options.count - 1));
      const s = this.measurementsCache[e];
      if (!s)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (n === "auto")
        if (s.end >= a + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          n = "start";
        else
          return [a, n];
      if (n === "end" && e === this.options.count - 1)
        return [this.getMaxScrollOffset(), n];
      const l = n === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(l, n, s.size),
        n
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (e, { align: n = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(e, n), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (e, { align: n = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), e = Math.max(0, Math.min(e, this.options.count - 1)), this.currentScrollToIndex = e;
      let i = 0;
      const a = 10, l = (h) => {
        if (!this.targetWindow) return;
        const f = this.getOffsetForIndex(e, h);
        if (!f) {
          console.warn("Failed to get offset for index:", e);
          return;
        }
        const [d, c] = f;
        this._scrollToOffset(d, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const x = () => {
            if (this.currentScrollToIndex !== e) return;
            const b = this.getScrollOffset(), M = this.getOffsetForIndex(e, c);
            if (!M) {
              console.warn("Failed to get offset for index:", e);
              return;
            }
            Is(M[0], b) || m(c);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(x) : x();
        });
      }, m = (h) => {
        this.targetWindow && this.currentScrollToIndex === e && (i++, i < a ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", i, a), this.targetWindow.requestAnimationFrame(() => l(h))) : console.warn(
          `Failed to scroll to index ${e} after ${a} attempts.`
        ));
      };
      l(n);
    }, this.scrollBy = (e, { behavior: n } = {}) => {
      n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + e, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var e;
      const n = this.getMeasurements();
      let s;
      if (n.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((e = n[n.length - 1]) == null ? void 0 : e.end) ?? 0;
      else {
        const i = Array(this.options.lanes).fill(null);
        let a = n.length - 1;
        for (; a >= 0 && i.some((l) => l === null); ) {
          const l = n[a];
          i[l.lane] === null && (i[l.lane] = l.end), a--;
        }
        s = Math.max(...i.filter((l) => l !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (e, {
      adjustments: n,
      behavior: s
    }) => {
      this.options.scrollToFn(e, { behavior: s, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(o);
  }
}
const En = (t, o, e, n) => {
  for (; t <= o; ) {
    const s = (t + o) / 2 | 0, i = e(s);
    if (i < n)
      t = s + 1;
    else if (i > n)
      o = s - 1;
    else
      return s;
  }
  return t > 0 ? t - 1 : 0;
};
function Fs({
  measurements: t,
  outerSize: o,
  scrollOffset: e,
  lanes: n
}) {
  const s = t.length - 1, i = (m) => t[m].start;
  if (t.length <= n)
    return {
      startIndex: 0,
      endIndex: s
    };
  let a = En(
    0,
    s,
    i,
    e
  ), l = a;
  if (n === 1)
    for (; l < s && t[l].end < e + o; )
      l++;
  else if (n > 1) {
    const m = Array(n).fill(0);
    for (; l < s && m.some((f) => f < e + o); ) {
      const f = t[l];
      m[f.lane] = f.end, l++;
    }
    const h = Array(n).fill(e + o);
    for (; a >= 0 && h.some((f) => f >= e); ) {
      const f = t[a];
      h[f.lane] = f.start, a--;
    }
    a = Math.max(0, a - a % n), l = Math.min(s, l + (n - 1 - l % n));
  }
  return { startIndex: a, endIndex: l };
}
const ht = typeof document < "u" ? p.useLayoutEffect : p.useEffect;
function Ls({
  useFlushSync: t = !0,
  ...o
}) {
  const e = p.useReducer(() => ({}), {})[1], n = {
    ...o,
    onChange: (i, a) => {
      var l;
      t && a ? Un(e) : e(), (l = o.onChange) == null || l.call(o, i, a);
    }
  }, [s] = p.useState(
    () => new zs(n)
  );
  return s.setOptions(n), ht(() => s._didMount(), []), ht(() => s._willUpdate()), s;
}
function ft(t) {
  return Ls({
    observeElementRect: Os,
    observeElementOffset: Ts,
    scrollToFn: Ps,
    ...t
  });
}
const uo = ({
  data: t,
  columns: o,
  keyExtractor: e,
  onRowClick: n,
  isLoading: s,
  loadingRowCount: i = 10,
  emptyMessage: a = "No results",
  error: l,
  onRetry: m,
  sortConfig: h,
  onSort: f,
  selected: d,
  onSelect: c,
  onSelectAll: x,
  selectAllLabel: b = "Select all rows",
  getRowSelectionLabel: M,
  className: N,
  stickyHeader: _,
  columnVisibility: E,
  rowHeight: T = 53,
  containerHeight: A = 600,
  overscan: F = 5,
  onEndReached: Z,
  onEndReachedThreshold: J = 2,
  enableColumnVirtualization: ae = !1,
  pagination: te,
  toolbar: P,
  bulkActions: ne,
  showColumnVisibility: oe,
  onColumnVisibilityChange: le,
  savedViews: K,
  showSavedViews: ge,
  isFetchingNextPage: he,
  ...U
}) => {
  var st;
  const V = mt(null), [y, L] = pt(""), W = t.length > 0 && d && t.every((u) => d.has(e(u))), Y = d && d.size > 0 && !W, ie = be(() => o.filter((u) => !E || E[u.key] !== !1), [o, E]), { pinnedLeft: X, unpinned: Q, pinnedRight: B } = be(() => {
    const u = [], v = [], $ = [];
    return ie.forEach((z) => {
      z.pinned === "left" ? u.push(z) : z.pinned === "right" ? v.push(z) : $.push(z);
    }), { pinnedLeft: u, unpinned: $, pinnedRight: v };
  }, [ie]), g = (u) => typeof u.width == "number" ? u.width : typeof u.width == "string" && u.width.endsWith("px") ? parseInt(u.width, 10) : 150, I = ft({
    count: t.length,
    getScrollElement: () => V.current,
    estimateSize: () => T,
    overscan: F
  }), D = ft({
    count: Q.length,
    getScrollElement: () => V.current,
    estimateSize: (u) => g(Q[u]),
    horizontal: !0,
    overscan: F
  });
  Fn(() => {
    const [u] = [...I.getVirtualItems()].reverse();
    u && u.index >= t.length - 1 - J && !s && !he && Z && Z();
  }, [
    I.getVirtualItems(),
    t.length,
    s,
    he,
    Z,
    J
  ]);
  const S = (u, v) => u.render ? u.render(v) : v[u.key], R = (u) => {
    if (!u.sortable) return null;
    const v = (h == null ? void 0 : h.key) === u.key;
    return /* @__PURE__ */ r("span", { className: "ml-1 text-muted-foreground", children: v ? (h == null ? void 0 : h.direction) === "asc" ? /* @__PURE__ */ r(vt, { className: "h-3 w-3" }) : /* @__PURE__ */ r(bt, { className: "h-3 w-3" }) : /* @__PURE__ */ r(St, { className: "h-3 w-3" }) });
  }, k = "flex items-center px-6 py-3 text-xs font-medium uppercase tracking-wider text-muted-foreground bg-muted border-b border-border h-full", j = "flex items-center px-6 py-4 text-sm text-foreground bg-background border-b border-border h-full whitespace-nowrap", q = (u, v, $, z) => /* @__PURE__ */ w(
    "div",
    {
      className: C(
        k,
        u.align === "center" && "justify-center",
        u.align === "right" && "justify-end",
        u.sortable && "cursor-pointer hover:bg-muted/80 select-none",
        $ && "border-r border-border",
        z && "border-l border-border"
      ),
      style: { width: g(u), ...v },
      onClick: () => u.sortable && (f == null ? void 0 : f(u.key)),
      role: "columnheader",
      children: [
        u.header,
        R(u)
      ]
    },
    u.key
  ), Se = (u, v, $, z, re) => /* @__PURE__ */ r(
    "div",
    {
      className: C(
        j,
        u.align === "center" && "justify-center",
        u.align === "right" && "justify-end",
        z && "border-r border-border",
        re && "border-l border-border",
        (d == null ? void 0 : d.has(e(v))) && "bg-accent/50"
      ),
      style: { width: g(u), ...$ },
      role: "gridcell",
      children: S(u, v)
    },
    `${e(v)}-${u.key}`
  ), fe = 48, Sn = () => /* @__PURE__ */ r(
    "div",
    {
      className: C(k, "justify-center border-r border-border sticky left-0 z-30"),
      style: { width: fe, minWidth: fe },
      children: /* @__PURE__ */ r(
        "input",
        {
          type: "checkbox",
          checked: W,
          ref: (u) => {
            u && (u.indeterminate = !!Y);
          },
          onChange: () => x == null ? void 0 : x(t.map(e)),
          "aria-label": b,
          className: "rounded border-border text-primary focus:ring-ring"
        }
      )
    }
  ), _n = (u) => /* @__PURE__ */ r(
    "div",
    {
      className: C(
        j,
        "justify-center border-r border-border sticky left-0 z-10",
        (d == null ? void 0 : d.has(e(u))) && "bg-accent/50"
      ),
      style: { width: fe, minWidth: fe },
      onClick: (v) => v.stopPropagation(),
      children: /* @__PURE__ */ r(
        "input",
        {
          type: "checkbox",
          checked: d == null ? void 0 : d.has(e(u)),
          onChange: (v) => {
            v.stopPropagation(), c == null || c(e(u));
          },
          "aria-label": (M == null ? void 0 : M(u, 0)) ?? "Select row",
          className: "rounded border-border text-primary focus:ring-ring"
        }
      )
    }
  ), In = X.reduce((u, v) => u + g(v), 0) + (c ? fe : 0), Dn = B.reduce((u, v) => u + g(v), 0), tt = (u) => {
    let v = c ? fe : 0;
    for (let $ = 0; $ < u; $++) v += g(X[$]);
    return v;
  }, nt = (u) => {
    let v = 0;
    for (let $ = B.length - 1; $ > u; $--) v += g(B[$]);
    return v;
  }, Rn = I.getVirtualItems(), _e = D.getVirtualItems(), Ge = D.getTotalSize(), rt = In + Ge + Dn, kn = (u, v) => {
    le && le({
      ...E,
      [u]: v
    });
  }, On = () => /* @__PURE__ */ w(Pe, { children: [
    /* @__PURE__ */ r(ze, { asChild: !0, children: /* @__PURE__ */ w(ee, { variant: "outline", size: "sm", className: "h-8 gap-1 ml-auto", children: [
      /* @__PURE__ */ r(wt, { className: "h-4 w-4" }),
      /* @__PURE__ */ r("span", { className: "hidden sm:inline", children: "Columns" })
    ] }) }),
    /* @__PURE__ */ w(xe, { align: "end", className: "w-[150px]", children: [
      /* @__PURE__ */ r(Ne, { children: "Toggle Columns" }),
      /* @__PURE__ */ r(de, {}),
      o.map((u) => /* @__PURE__ */ r(
        et,
        {
          className: "capitalize",
          checked: (E == null ? void 0 : E[u.key]) !== !1,
          onCheckedChange: (v) => kn(u.key, v),
          children: u.header
        },
        u.key
      ))
    ] })
  ] }), Tn = () => K ? /* @__PURE__ */ w(Pe, { children: [
    /* @__PURE__ */ r(ze, { asChild: !0, children: /* @__PURE__ */ w(ee, { variant: "outline", size: "sm", className: "h-8 gap-1", children: [
      /* @__PURE__ */ r(_t, { className: "h-4 w-4" }),
      /* @__PURE__ */ r("span", { className: "hidden sm:inline", children: "Views" })
    ] }) }),
    /* @__PURE__ */ w(xe, { align: "end", className: "w-[200px]", children: [
      /* @__PURE__ */ r(Ne, { children: "Saved Views" }),
      /* @__PURE__ */ r(de, {}),
      K.views.length === 0 ? /* @__PURE__ */ r("div", { className: "p-2 text-sm text-muted-foreground", children: "No saved views" }) : K.views.map((u) => /* @__PURE__ */ w("div", { className: "flex items-center justify-between px-2 py-1.5 hover:bg-accent hover:text-accent-foreground rounded-[var(--ds-radius-sm)] cursor-pointer group", children: [
        /* @__PURE__ */ r("div", { className: "flex-1 text-sm", onClick: () => K.onLoad(u), children: u.name }),
        /* @__PURE__ */ r(
          "button",
          {
            onClick: (v) => {
              v.stopPropagation(), K.onDelete(u.id);
            },
            className: "opacity-0 group-hover:opacity-100 p-1 hover:bg-destructive/10 text-destructive rounded-[var(--ds-radius-sm)]",
            children: /* @__PURE__ */ r(It, { className: "h-3 w-3" })
          }
        )
      ] }, u.id)),
      /* @__PURE__ */ r(de, {}),
      /* @__PURE__ */ r("div", { className: "p-2", children: /* @__PURE__ */ w(
        "form",
        {
          onSubmit: (u) => {
            u.preventDefault(), y.trim() && (K.onSave(y), L(""));
          },
          className: "flex gap-2",
          children: [
            /* @__PURE__ */ r(
              "input",
              {
                className: "flex h-7 w-full rounded-[var(--ds-radius-md)] border border-input bg-transparent px-2 py-1 text-sm shadow-elevation-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                placeholder: "New view name...",
                value: y,
                onChange: (u) => L(u.target.value)
              }
            ),
            /* @__PURE__ */ r(ee, { type: "submit", size: "sm", className: "h-7 px-2", disabled: !y.trim(), children: /* @__PURE__ */ r(yt, { className: "h-3 w-3" }) })
          ]
        }
      ) })
    ] })
  ] }) : null, Ie = d && d.size > 0, An = /* @__PURE__ */ w(se, { children: [
    ge && Tn(),
    oe && On(),
    P == null ? void 0 : P.actions
  ] });
  return /* @__PURE__ */ w("div", { className: C("flex flex-col gap-4", N), ...U, children: [
    P && /* @__PURE__ */ r(
      Rt,
      {
        search: Ie ? void 0 : P.search,
        filters: Ie ? void 0 : P.filters,
        actions: Ie && ne ? ne : An,
        children: Ie ? /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ w(Oe, { variant: "small", className: "font-medium text-primary", children: [
          d.size,
          " selected"
        ] }) }) : P.children
      }
    ),
    /* @__PURE__ */ r("div", { className: "overflow-hidden rounded-[var(--ds-radius-lg)] border border-border shadow-elevation-1 relative bg-background", children: /* @__PURE__ */ r(
      "div",
      {
        ref: V,
        className: "overflow-auto",
        style: { height: A, maxHeight: A },
        role: "grid",
        "aria-busy": s,
        children: /* @__PURE__ */ w(
          "div",
          {
            style: {
              height: I.getTotalSize(),
              width: rt,
              position: "relative"
            },
            children: [
              /* @__PURE__ */ w(
                "div",
                {
                  className: C("flex sticky top-0 z-20 shadow-sm", _ ? "sticky" : "relative"),
                  style: {
                    width: rt,
                    height: T,
                    top: 0,
                    position: _ ? "sticky" : "absolute"
                    // If not sticky header, it scrolls away? Wait, rowVirtualizer handles vertical scroll.
                  },
                  role: "row",
                  children: [
                    c && Sn(),
                    X.map((u, v) => /* @__PURE__ */ r(
                      "div",
                      {
                        className: "sticky z-30",
                        style: { left: tt(v) },
                        children: q(u, void 0, v === X.length - 1)
                      },
                      u.key
                    )),
                    /* @__PURE__ */ r("div", { style: { position: "relative", width: Ge, height: "100%", display: "flex" }, children: ae ? /* @__PURE__ */ w(se, { children: [
                      /* @__PURE__ */ r("div", { style: { width: ((st = _e[0]) == null ? void 0 : st.start) ?? 0 } }),
                      _e.map((u) => {
                        const v = Q[u.index];
                        return q(v, { width: u.size });
                      })
                    ] }) : Q.map((u) => q(u)) }),
                    B.map((u, v) => /* @__PURE__ */ r(
                      "div",
                      {
                        className: "sticky z-30",
                        style: { right: nt(v) },
                        children: q(u, void 0, !1, v === 0)
                      },
                      u.key
                    ))
                  ]
                }
              ),
              s && t.length === 0 ? /* @__PURE__ */ r("div", { className: "absolute top-[53px] w-full p-4 space-y-2", children: Array.from({ length: i }).map((u, v) => /* @__PURE__ */ w("div", { className: "flex gap-4", children: [
                /* @__PURE__ */ r(ke, { className: "h-8 w-8" }),
                /* @__PURE__ */ r(ke, { className: "h-8 w-full" })
              ] }, v)) }) : l ? /* @__PURE__ */ r("div", { className: "absolute top-[53px] w-full p-8 flex justify-center", children: /* @__PURE__ */ r(Fe, { title: "Error", description: l.message || gt, onRetry: m }) }) : t.length === 0 ? /* @__PURE__ */ r("div", { className: "absolute top-[53px] w-full p-12 flex justify-center", children: /* @__PURE__ */ r(Ve, { title: "No results", description: a }) }) : Rn.map((u) => {
                var $;
                const v = t[u.index];
                return /* @__PURE__ */ w(
                  "div",
                  {
                    "data-index": u.index,
                    ref: I.measureElement,
                    className: C(
                      "flex absolute left-0 w-full transition-colors hover:bg-muted/50",
                      n && "cursor-pointer",
                      (d == null ? void 0 : d.has(e(v))) && "bg-accent/50"
                    ),
                    style: {
                      transform: `translateY(${u.start}px)`,
                      // Use transform for performance?
                      // Wait, if we use transform, sticky children might break in some browsers/contexts?
                      // react-virtual docs says sticky elements need specific handling.
                      // "position: sticky is not supported inside a virtual list" usually.
                      // However, if we use `top` instead of `transform`, it works better for sticky.
                      top: u.start,
                      height: u.size,
                      position: "absolute"
                    },
                    onClick: () => n == null ? void 0 : n(v),
                    role: "row",
                    children: [
                      c && _n(v),
                      X.map((z, re) => /* @__PURE__ */ r(
                        "div",
                        {
                          className: "sticky z-10",
                          style: { left: tt(re) },
                          children: Se(z, v, void 0, re === X.length - 1)
                        },
                        z.key
                      )),
                      /* @__PURE__ */ r("div", { style: { position: "relative", width: Ge, height: "100%", display: "flex" }, children: ae ? /* @__PURE__ */ w(se, { children: [
                        /* @__PURE__ */ r("div", { style: { width: (($ = _e[0]) == null ? void 0 : $.start) ?? 0 } }),
                        _e.map((z) => {
                          const re = Q[z.index];
                          return Se(re, v, { width: z.size });
                        })
                      ] }) : Q.map((z) => Se(z, v)) }),
                      B.map((z, re) => /* @__PURE__ */ r(
                        "div",
                        {
                          className: "sticky z-10",
                          style: { right: nt(re) },
                          children: Se(z, v, void 0, !1, re === 0)
                        },
                        z.key
                      ))
                    ]
                  },
                  u.key
                );
              })
            ]
          }
        )
      }
    ) }),
    te && /* @__PURE__ */ r("div", { className: "flex items-center justify-end py-4", children: /* @__PURE__ */ r(Dt, { ...te }) })
  ] });
};
export {
  St as C,
  co as D,
  Ve as E,
  ao as N,
  Dt as P,
  mr as T,
  uo as a,
  Rt as b,
  Pe as c,
  ze as d,
  xe as e,
  Ss as f
};
